import { render, staticRenderFns } from "./SelectDoctorStep.vue?vue&type=template&id=c2844dd2&scoped=true"
import script from "./SelectDoctorStep.vue?vue&type=script&lang=js"
export * from "./SelectDoctorStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2844dd2",
  null
  
)

export default component.exports